import { cn } from '../lib/cn.js';

/** Abas com semântica ARIA (tablist/tab) e setas do teclado. O conteúdo fica com o chamador. */
export function Tabs<T extends string>({ tabs, value, onChange, className }: {
  tabs: { value: T; label: string; count?: number }[];
  value: T;
  onChange: (v: T) => void;
  className?: string;
}) {
  const idx = tabs.findIndex((t) => t.value === value);
  return (
    <div role="tablist" className={cn('flex gap-1 border-b border-border', className)}
      onKeyDown={(e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = tabs[(idx + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]!;
        onChange(next.value);
      }}>
      {tabs.map((t) => (
        <button key={t.value} type="button" role="tab" aria-selected={t.value === value} tabIndex={t.value === value ? 0 : -1}
          onClick={() => onChange(t.value)}
          className={cn('-mb-px flex h-10 items-center gap-2 border-b-2 px-3 text-sm font-medium transition-colors',
            t.value === value ? 'border-primary text-fg' : 'border-transparent text-fg-muted hover:text-fg')}>
          {t.label}
          {t.count !== undefined && <span className="rounded-full bg-surface-muted px-1.5 text-[11px] text-fg-muted tabular-nums">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
